export default "__VITE_ASSET__2kqFsk3S__"